var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinopsys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_17_4",
    "data-name": "Component 17 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184,
    height: 46,
    viewBox: "0 0 184 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 184,
    height: 46,
    transform: "translate(29 1828)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(-29 -1828)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(-121 1120.201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finopsys",
    transform: "translate(197.5 717.189)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M534.769,771.545V783.91h-2.438V771.545Zm-.813,0h5.529v2.208h-5.529Zm0,4.981h5.352v2.1h-5.352Z",
    transform: "translate(-532.331 -770.927)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M692.978,771.545V783.91h-2.561V771.545Z",
    transform: "translate(-675.65 -770.927)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M814.352,765.544v12.983l-8.8-8.284v7.666h-2.438V764.926l8.8,8.284v-7.666Z",
    transform: "translate(-777.823 -764.926)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M1221.469,771.545V783.91h-2.526V771.545Zm-.989,0h2.455a5.934,5.934,0,0,1,2.5.477,3.557,3.557,0,0,1,1.581,1.36,4.29,4.29,0,0,1,0,4.2,3.538,3.538,0,0,1-1.581,1.369,5.934,5.934,0,0,1-2.5.477h-2.455v-2.137h2.455a2.5,2.5,0,0,0,1.59-.459,1.848,1.848,0,0,0,0-2.694,2.538,2.538,0,0,0-1.59-.45h-2.455Z",
    transform: "translate(-1154.805 -770.927)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M1383.848,778.559a3.545,3.545,0,0,0,1.033.795,2.684,2.684,0,0,0,1.219.283,1.9,1.9,0,0,0,1.236-.389,1.294,1.294,0,0,0,.477-1.06,1.425,1.425,0,0,0-.292-.936,2.5,2.5,0,0,0-.865-.627q-.574-.274-1.4-.592-.442-.159-1.016-.433a5.035,5.035,0,0,1-1.086-.706,3.574,3.574,0,0,1-.848-1.06,3.159,3.159,0,0,1-.336-1.51,3.1,3.1,0,0,1,.539-1.828,3.484,3.484,0,0,1,1.466-1.184,5.028,5.028,0,0,1,2.075-.415,4.814,4.814,0,0,1,2.04.4,4.591,4.591,0,0,1,1.431,1.007,5.124,5.124,0,0,1,.892,1.263l-1.978,1.1a4.008,4.008,0,0,0-.592-.8,2.826,2.826,0,0,0-.786-.583,2.223,2.223,0,0,0-1.007-.221,1.584,1.584,0,0,0-1.113.344,1.066,1.066,0,0,0-.371.8,1.184,1.184,0,0,0,.3.8,2.972,2.972,0,0,0,.919.654,12.564,12.564,0,0,0,1.554.627,7.074,7.074,0,0,1,1.157.53,4.755,4.755,0,0,1,1.007.768,3.28,3.28,0,0,1,.707,1.06,3.6,3.6,0,0,1,.256,1.4,3.548,3.548,0,0,1-.353,1.608,3.476,3.476,0,0,1-.971,1.192,4.556,4.556,0,0,1-1.386.742,5.086,5.086,0,0,1-1.616.256,5.169,5.169,0,0,1-2.111-.433,5.41,5.41,0,0,1-1.7-1.175,5.863,5.863,0,0,1-1.13-1.607l1.8-1.272A6.5,6.5,0,0,0,1383.848,778.559Z",
    transform: "translate(-1301.896 -768.526)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M1556.216,771.545l-4.257,7.242v5.123H1549.4v-5.1l-4.257-7.26h2.879l2.65,4.981,2.667-4.981Z",
    transform: "translate(-1450.532 -770.927)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M1729.9,778.559a3.541,3.541,0,0,0,1.033.795,2.684,2.684,0,0,0,1.219.283,1.9,1.9,0,0,0,1.236-.389,1.293,1.293,0,0,0,.477-1.06,1.425,1.425,0,0,0-.291-.936,2.5,2.5,0,0,0-.865-.627q-.574-.274-1.4-.592-.442-.159-1.016-.433a5.038,5.038,0,0,1-1.086-.706,3.579,3.579,0,0,1-.848-1.06,3.162,3.162,0,0,1-.335-1.51,3.1,3.1,0,0,1,.539-1.828,3.484,3.484,0,0,1,1.466-1.184,5.03,5.03,0,0,1,2.076-.415,4.813,4.813,0,0,1,2.04.4,4.593,4.593,0,0,1,1.431,1.007,5.127,5.127,0,0,1,.892,1.263l-1.978,1.1a4,4,0,0,0-.592-.8,2.827,2.827,0,0,0-.786-.583,2.222,2.222,0,0,0-1.007-.221,1.585,1.585,0,0,0-1.113.344,1.066,1.066,0,0,0-.371.8,1.184,1.184,0,0,0,.3.8,2.971,2.971,0,0,0,.919.654,12.572,12.572,0,0,0,1.554.627,7.085,7.085,0,0,1,1.157.53,4.758,4.758,0,0,1,1.007.768,3.278,3.278,0,0,1,.706,1.06,3.6,3.6,0,0,1,.256,1.4,3.547,3.547,0,0,1-.353,1.608,3.473,3.473,0,0,1-.971,1.192,4.552,4.552,0,0,1-1.387.742,5.083,5.083,0,0,1-1.616.256,5.169,5.169,0,0,1-2.111-.433,5.409,5.409,0,0,1-1.7-1.175,5.863,5.863,0,0,1-1.13-1.607l1.8-1.272A6.5,6.5,0,0,0,1729.9,778.559Z",
    transform: "translate(-1615.622 -768.526)",
    fill: "#fff"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M1004.671,774.624a3.684,3.684,0,0,1,3.374-1.978,3.812,3.812,0,0,1,2.031.53,3.621,3.621,0,0,1,1.343,1.448,4.27,4.27,0,0,1,.448,1.539h2.692a6.492,6.492,0,0,0-.464-2.025,6.014,6.014,0,0,0-1.378-2.04,6.255,6.255,0,0,0-2.076-1.334,7.412,7.412,0,0,0-5.184,0,6.116,6.116,0,0,0-3.453,3.374,6.389,6.389,0,0,0-.472,2.025h2.675A4.155,4.155,0,0,1,1004.671,774.624Z",
    transform: "translate(-760.202 -52.606)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M1011.461,847.552A3.684,3.684,0,0,1,1010.11,849a3.827,3.827,0,0,1-5.388-1.448,4.123,4.123,0,0,1-.453-1.451h-2.681a6.7,6.7,0,0,0,.449,1.937,6.108,6.108,0,0,0,1.36,2.075,6.215,6.215,0,0,0,2.076,1.369,7.325,7.325,0,0,0,5.246,0,6.119,6.119,0,0,0,2.067-1.369,6.288,6.288,0,0,0,1.36-2.075,6.6,6.6,0,0,0,.458-1.937h-2.7A4.184,4.184,0,0,1,1011.461,847.552Z",
    transform: "translate(-760.254 -121.329)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(163 712.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(10.066 6.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M284.983,792.69h-1.635a4.629,4.629,0,1,1-.209-1.386,4.637,4.637,0,0,1,.209,1.386h3.269a7.9,7.9,0,1,0-.357,2.357,7.911,7.911,0,0,0,.357-2.357Z",
    transform: "translate(-270.762 -784.762)",
    fill: "#1de4ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M179.758,721.583H177.89a5.581,5.581,0,0,1-7.747,5.139,5.607,5.607,0,0,1-2.455-2.023,5.589,5.589,0,0,1-.514-5.287,5.606,5.606,0,0,1,2.023-2.455,5.589,5.589,0,0,1,5.287-.514,5.606,5.606,0,0,1,2.455,2.023,5.541,5.541,0,0,1,.951,3.117h3.736a9.278,9.278,0,1,0-.419,2.769,9.292,9.292,0,0,0,.419-2.769Z",
    transform: "translate(-163 -712.27)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M280.387,793.62a4.659,4.659,0,0,1,.907,8.2,4.669,4.669,0,0,1-4.416.429,4.684,4.684,0,0,1-2.051-1.69,4.652,4.652,0,0,1,.1-5.353l-2.637-1.932a7.924,7.924,0,1,0,9.287-2.7l-1.192,3.045Z",
    transform: "translate(-260.696 -783.261)",
    fill: "#1de4ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Powered_by_Vegvizer",
    "data-name": "Powered by Vegvizer",
    transform: "translate(227.423 1042.664)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M-117.653,821.194c0,1.342-.973,2.153-2.576,2.153h-1.692v1.989h-.666v-6.3h2.358C-118.626,819.034-117.653,819.845-117.653,821.194Zm-.667,0c0-1.007-.666-1.584-1.926-1.584h-1.675v3.151h1.675C-118.986,822.761-118.32,822.185-118.32,821.194Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M-116.854,822.968a2.329,2.329,0,0,1,2.413-2.4,2.321,2.321,0,0,1,2.4,2.4,2.329,2.329,0,0,1-2.4,2.413A2.336,2.336,0,0,1-116.854,822.968Zm4.168,0a1.726,1.726,0,0,0-1.755-1.845,1.734,1.734,0,0,0-1.765,1.845,1.733,1.733,0,0,0,1.765,1.845A1.726,1.726,0,0,0-112.686,822.968Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M-103.919,820.6l-1.791,4.735h-.6l-1.495-3.88-1.5,3.88h-.6l-1.782-4.735h.612l1.485,4.024,1.522-4.024h.549l1.513,4.024,1.5-4.024Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M-98.97,823.166h-3.961a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.295,2.4C-98.961,823.022-98.97,823.095-98.97,823.166Zm-3.961-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-102.931,822.689Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M-95.271,820.564v.622c-.054,0-.108-.009-.153-.009a1.532,1.532,0,0,0-1.594,1.746v2.413h-.639V820.6h.612v.926A1.786,1.786,0,0,1-95.271,820.564Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M-90.042,823.166H-94a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.3,2.4C-90.033,823.022-90.042,823.095-90.042,823.166ZM-94,822.689h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-94,822.689Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M-84.408,818.656v6.68h-.612V824.4a2.05,2.05,0,0,1-1.828.982,2.3,2.3,0,0,1-2.359-2.413,2.292,2.292,0,0,1,2.359-2.4,2.07,2.07,0,0,1,1.8.937v-2.845Zm-.63,4.312a1.732,1.732,0,0,0-1.756-1.845,1.733,1.733,0,0,0-1.764,1.845,1.733,1.733,0,0,0,1.764,1.845A1.732,1.732,0,0,0-85.038,822.968Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M-75.471,822.968a2.3,2.3,0,0,1-2.359,2.413,2.049,2.049,0,0,1-1.827-.982v.937h-.613v-6.68h.64V821.5a2.068,2.068,0,0,1,1.8-.937A2.291,2.291,0,0,1-75.471,822.968Zm-.639,0a1.739,1.739,0,0,0-1.765-1.845,1.733,1.733,0,0,0-1.764,1.845,1.733,1.733,0,0,0,1.764,1.845A1.739,1.739,0,0,0-76.11,822.968Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M-70.323,820.6l-2.368,5.3c-.4.927-.9,1.225-1.576,1.225a1.621,1.621,0,0,1-1.152-.433l.3-.477a1.182,1.182,0,0,0,.864.36c.424,0,.712-.2.982-.792l.207-.459-2.116-4.726h.666l1.783,4.024,1.782-4.024Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M-61.692,819.034l-2.791,6.3h-.657l-2.791-6.3h.72l2.413,5.474,2.431-5.474Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M-57.156,823.166h-3.962a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.361.414a2.331,2.331,0,0,1-1.828.775,2.345,2.345,0,0,1-2.485-2.413,2.281,2.281,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.3,2.4C-57.147,823.022-57.156,823.095-57.156,823.166Zm-3.962-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.646,1.646,0,0,0-61.118,822.689Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M-51.459,820.6v4.159a2.078,2.078,0,0,1-2.368,2.368,3.3,3.3,0,0,1-2.206-.73l.325-.486a2.818,2.818,0,0,0,1.863.649c1.2,0,1.746-.55,1.746-1.72v-.6a2.129,2.129,0,0,1-1.845.919,2.266,2.266,0,0,1-2.377-2.3,2.253,2.253,0,0,1,2.377-2.288,2.14,2.14,0,0,1,1.873.946V820.6Zm-.622,2.251a1.693,1.693,0,0,0-1.8-1.729,1.685,1.685,0,0,0-1.791,1.729,1.692,1.692,0,0,0,1.791,1.737A1.7,1.7,0,0,0-52.081,822.852Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M-45.69,820.6l-2.107,4.735h-.658l-2.1-4.735h.666l1.774,4.033,1.791-4.033Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M-44.936,819.106a.461.461,0,0,1,.468-.45A.454.454,0,0,1-44,819.1a.459.459,0,0,1-.468.468A.463.463,0,0,1-44.936,819.106Zm.144,1.495h.639v4.735h-.639Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M-39.031,824.8v.531h-3.853v-.423l2.98-3.772H-42.83v-.54h3.745v.422l-2.98,3.782Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M-33.729,823.166h-3.962a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.295,2.4C-33.721,823.022-33.729,823.095-33.729,823.166Zm-3.962-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-37.691,822.689Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M-30.031,820.564v.622c-.054,0-.108-.009-.153-.009a1.532,1.532,0,0,0-1.594,1.746v2.413h-.639V820.6h.612v.926A1.787,1.787,0,0,1-30.031,820.564Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinopsys);
export default __webpack_public_path__ + "static/media/finopsys.6326a35654c00216f1908df8c9c87c1b.svg";
export { ForwardRef as ReactComponent };